export const initialServiceFormState = {
  title: "",
  content: "",
  visibility: true,
  publishAt: new Date(new Date().getTime()),
  featuredImage: undefined,
  featuredImageAlt: "",
  photoCredit: "",
  author: "",
  avatar: "",
  exerpt: "",
  seoTitle: "",
  seoDescription: "",
  handle: "",
  duration: 0,
  media: [],
  location: "",
  categories: [],
  faq: [],
  problem: [],
};

export const getUpdatedData = (values, post) => ({
  title: values.title,
  content: values.content,
  visibility: values.visibility,
  publishAt: values.publishAt,
  featuredImage: post.featuredImage,
  featuredImageAlt: values.featuredImageAlt,
  photoCredit: values.photoCredit,
  author: values.author,
  avatar: values.avatar,
  exerpt: values.exerpt,
  categories: values.categories,
  seoTitle: values.seoTitle,
  seoDescription: values.seoDescription,
  handle: values.handle,
  duration: values.duration,
  media: post.media,
  faq: values.faq?.map(({ id, question, answer }) => ({
    id,
    question,
    answer,
  })),
  problem: values.problem,
  location: values.location,
  _version: post._version,
});

